import request from 'utils/request';

export async function clearData(params) {
  return request({
    url: '/data/clear',
    method: 'delete',
    data: params,
  });
}

export async function copyData(params) {
  return request({
    url: '/data/copy',
    method: 'post',
    data: params,
  });
}


export async function searchCompany(params) {
  return request({
    url: '/data/companies',
    method: 'get',
    data: params,
  });
}

export async function recalcSalePurchase(params) {
  return request({
    url: '/data/recalc',
    method: 'post',
    data: params,
  });
}


export default {};



// WEBPACK FOOTER //
// ./src/services/data.js